import { createListenerMiddleware } from '@reduxjs/toolkit';

import { getBetType } from '../../utils/bets';
import { fetchBonusCampaignsAction } from '../apiActions/fetchBonusPromotionAction';
import { fetchPlayerConfigSyncAction } from '../apiActions/fetchPlayerConfigSyncAction';
import type { CoreRootState } from '../CoreStore';
import { autoplayActions } from '../slices/autoplay/slice';
import { betActions } from '../slices/bets/slice';
import { selectClaimedBonus } from '../slices/bonusPromotions/selectors';
import { ChipTypes } from '../slices/chips/types';
import { toastActions } from '../slices/toast/slice';

export const autoplaySyncMiddleware = createListenerMiddleware<CoreRootState>();

autoplaySyncMiddleware.startListening({
  actionCreator: autoplayActions.finishAutoplayOnboarding,
  effect: (_, { dispatch, getState, unsubscribe }) => {
    const { JSESSIONID, metaServer: url } = getState().config?.session ?? {};

    if (!(JSESSIONID && url)) return;

    const timeStamp = Date.now();

    const body = { autoplay_onboarded: true };

    dispatch(
      fetchPlayerConfigSyncAction({
        JSESSIONID,
        ck: timeStamp.toString(),
        url: `${url}/api/ui/savePlayerConfigGeneric`,
        body,
      })
    );
    unsubscribe();
  },
});

autoplaySyncMiddleware.startListening({
  actionCreator: toastActions.createToast,
  effect: (action, { dispatch }) => {
    if (action.payload === 'AUTOPLAY_COMPLETED') {
      dispatch(autoplayActions.setComplete(true));
    }
  },
});
autoplaySyncMiddleware.startListening({
  actionCreator: fetchBonusCampaignsAction.fulfilled,
  effect: (_, { getState, dispatch }) => {
    const state = getState();
    const lastBet = state.bets.lastBet;

    const isAutoplayInProgress = state.autoplay.isInProgress;
    const isLastBetFreeChip = getBetType(lastBet) === ChipTypes.FreeChip;
    const hasFreeChipsEnded = selectClaimedBonus(state) === null;

    if (hasFreeChipsEnded && isLastBetFreeChip) {
      dispatch(betActions.clearLastBets());
      if (isAutoplayInProgress) {
        dispatch(toastActions.createToast('PROMO_FREE_CHIPS_BONUS_CONCLUDED'));
        dispatch(autoplayActions.stop());
      }
    }
  },
});
